import React, { Component } from "react";
import styled, { css, keyframes } from "styled-components";
import FieldOptions from "../components/FieldOptions";
import { connect } from "react-redux";
import { Background, Flex } from "../theme/styled";
import Logo from "../assets/logo.png";
import { FormattedMessage } from "react-intl";

const SlideInfinite = keyframes`
  50% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(5px));
  }
}
`;

const AnimateArrow = styled.div`
  animation: ${SlideInfinite} 2s linear 0s infinite;
`;

const FlexColumn = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 8px 0;
  span {
    display: block;
    margin-top: 8px;
    font-weight: bold;
    color: #000;
    font-size: 11px;
    text-transform: uppercase;
  }
  img.logo {
    margin-top: 4vw;
  }
`;

const Button = styled.button`
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  background: #00210b;
  border: none;
  color: #fff;
  width: 80px;
  font-size: 30px;
  opacity: 1;
  transition: 0.5s;
  cursor: pointer;
  ${props =>
    props.disabled &&
    css`
      opacity: 0;
    `};
  @media (max-width: 768px) {
    width: 100%;
    height: 50px;
    right: auto;
    top: auto;
    bottom: 0;
  }
`;

class ChooseField extends Component {
  onChange = field => {
    this.setState({ field });
  };
  state = { field: { type: null, size: null } };
  onNextButtonClicked = () => {
    const { field } = this.state;
    const { dispatch, history } = this.props;
    dispatch.field.set(field);
    history.push(`/edit?type=${field.type}&size=${field.size}`);
  };
  render() {
    const { field } = this.state;
    return (
      <Background>
        <FlexColumn>
          <img src={Logo} alt="sportgroup logo" class="logo"/>
          <span>
            <FormattedMessage
              id="app.logo"
              defaultMessage="Konfigurator boisk Sport Grupa"
            />
          </span>
        </FlexColumn>
        <h1>
          <FormattedMessage
            id="app.intro"
            defaultMessage="Wybierz rozmiar i typ boiska"
          />
        </h1>
        <FieldOptions value={field} onChange={this.onChange} />
        <Button
          onClick={this.onNextButtonClicked}
          disabled={!field.size || !field.type}
        >
          <AnimateArrow>&rarr;</AnimateArrow>
        </Button>
      </Background>
    );
  }
}

export default connect()(ChooseField);
